import { RootState } from 'apps/placeme/src/redux/store'
import { useSelector } from 'react-redux'
import { ISubscription } from '@dataplace.ai/types'
import { placemePlans } from '@dataplace.ai/constants'
import { OverviewData } from '../OverviewTile'
import { OVERVIEW_COST } from '../constants'

export type OverviewResult = {
  overview: OverviewData
} | undefined

export function useOverviewData(): {
  dataLoaded: boolean
  resultData?: OverviewData
  reportId?: string
  subscriptionId: string
  hasUnlimitedCredits: boolean
  subscriptionLoaded: boolean
  currentSubscriptionData: {
    loading: boolean
    error: string | null
    value?: ISubscription
  } | undefined
  isTrialOrWhite: boolean
  hasEnoughCredits: boolean
  overviewError: string | null
} {
  const {
    currentSubscriptionData, analyseId,
  } = useSelector((state: RootState) => state.location)
  const {
    overviewData, sortedTiles, overviewState,
  } = useSelector((state: RootState) => state.analysis)
  const stateData = sortedTiles?.find(result => result.categoryId === 'overview')?.value as OverviewResult
  const resultData = overviewData ?? stateData?.overview
  const dataLoaded = !!resultData
  const subscriptionId = currentSubscriptionData?.value?.subscriptionId ?? ''
  const hasUnlimitedCredits = currentSubscriptionData?.value?.planExact !== placemePlans.white
    && currentSubscriptionData?.value?.credits === 'unlimited'
  const subscriptionLoaded = !!currentSubscriptionData?.value
  const isTrialOrWhite = currentSubscriptionData?.value?.planExact === placemePlans.trial
  const hasEnoughCredits = !!(hasUnlimitedCredits || (currentSubscriptionData?.value?.credits
    && Number(currentSubscriptionData?.value?.credits) >= OVERVIEW_COST))
  const overviewError = overviewState?.error ?? null

  return {
    dataLoaded,
    resultData,
    reportId: analyseId,
    subscriptionId,
    hasUnlimitedCredits,
    subscriptionLoaded,
    currentSubscriptionData,
    isTrialOrWhite,
    hasEnoughCredits,
    overviewError,
  }
}
